// @/composables/useSnackbar.js
import { ref } from 'vue'

const snackbar = ref({
  show: false,
  text: '',
  color: 'success',
  timeout: 4000,
})

export const useSnackbar = () => {
  const showSnackbar = ({ text, color = 'success', timeout = 4000 }) => {
    snackbar.value = {
      show: true,
      text,
      color,
      timeout,
    }
  }

  const hideSnackbar = () => {
    snackbar.value.show = false
  }

  const success = text => {
    showSnackbar({ text, color: 'success' })
  }

  const error = text => {
    showSnackbar({ text, color: 'error' })
  }

  const warning = text => {
    showSnackbar({ text, color: 'warning' })
  }

  const info = text => {
    showSnackbar({ text, color: 'info' })
  }

  return {
    snackbar,
    showSnackbar,
    hideSnackbar,
    success,
    error,
    warning,
    info,
  }
}
